/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_11Inputs */



/**
* | output |
* | --- |
* | "Audio Description Plugin available as a team add-on" |
*
* @param {Signup_Feature_Starter_11Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_11 = /** @type {((inputs?: Signup_Feature_Starter_11Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_11Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "it") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "es") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
	return /** @type {LocalizedString} */ ("Audio Description Plugin available as a team add-on")
});